import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin, message, Button, Space, Table, Card } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import MeetingApprovalScreen from "./MeetingApprovalScreen";

const MeetingApprovalPage = () => {
  const { meetingId } = useParams();
  const navigate = useNavigate();
  const [meetingData, setMeetingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    if (meetingId) {
      fetchMeetingDetails();
    }
  }, [meetingId]);

  const fetchMeetingDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/meetings/${meetingId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch meeting details");
      }

      const data = await response.json();
      setMeetingData(data.data);
    } catch (error) {
      console.error("Error fetching meeting:", error);
      message.error("Failed to load meeting details");
      navigate("/meeting-approval-list");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (meeting) => {
    try {
      const response = await fetch(`/api/meetings/${meeting.meeting_id}/approve`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ meeting_id: meeting.meeting_id }),
      });

      if (!response.ok) {
        throw new Error("Failed to approve meeting");
      }

      const result = await response.json();
      if (result.status === "success") {
        setMeetingData({ ...meetingData, status: "approved" });
        message.success("Meeting approved successfully!");
        // Optionally navigate back to list after approval
        setTimeout(() => {
          navigate("/meeting-approval-list");
        }, 1500);
      }
    } catch (error) {
      console.error("Error approving meeting:", error);
      message.error("Failed to approve meeting");
      throw error;
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" tip="Loading meeting details..." />
      </div>
    );
  }

  return (
    <div style={{ padding: "24px" }}>
      <Space style={{ marginBottom: "24px" }}>
        <Button
          type="default"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/meeting-approval-list")}
        >
          Back to List
        </Button>
      </Space>

      {meetingData ? (
        <MeetingApprovalScreen
          meetingData={meetingData}
          onApprove={handleApprove}
          loading={loading}
        />
      ) : (
        <Card>
          <div style={{ textAlign: "center", padding: "50px" }}>
            <p>Meeting not found</p>
          </div>
        </Card>
      )}
    </div>
  );
};

export default MeetingApprovalPage;
